import deviceInfo from "../deviceInfo/deviceInfo";
// @ts-ignore no type
import debounce from "lodash/debounce";
import {deviceStore} from "../../redux/device/deviceStore";

/**
 * function to send device info to redux state
 */
const sendDeviceInfoToReduxState = () => {
  deviceStore.setDevice({
    info: {
      ...deviceInfo.deviceInfo,
      isMobile: deviceInfo.getIsMobile(),
      canDoRealtimePitchShifting: deviceInfo.canDoRealtimePitchShifting(),
    },
    hardware: deviceInfo.deviceHardwareInfo,
    browser: deviceInfo.deviceBrowserInfo,
  });
}

/**
 * debounced set device info to redux state, so it doesn't update more than every second
 */
const debouncedSendDeviceInfoToReduxState = debounce(sendDeviceInfoToReduxState, 500);

export const deviceStateService = {
  /**
   * Wires the device-state sync: pushes initial device info to redux on DOMContentLoaded
   * and updates redux on window resize (debounced). Returns a cleanup function that
   * removes both listeners — useful for tests and non-browser entry points.
   *
   * Must be called from an entry point (e.g. src/index.tsx) at app startup.
   */
  init(): () => void {
    const onDomReady = () => {
      sendDeviceInfoToReduxState();
      window.addEventListener('resize', debouncedSendDeviceInfoToReduxState);
    };
    document.addEventListener("DOMContentLoaded", onDomReady);
    return () => {
      document.removeEventListener("DOMContentLoaded", onDomReady);
      window.removeEventListener('resize', debouncedSendDeviceInfoToReduxState);
    };
  },
};
